function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module upload/filereader
 */

/* globals window */
import ObservableMixin from '@ckeditor/ckeditor5-utils/src/observablemixin';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
/**
 * Wrapper over the native `FileReader`.
 */

var FileReader = /*#__PURE__*/function () {
  /**
   * Creates an instance of the FileReader.
   */
  function FileReader() {
    var _this = this;

    _classCallCheck(this, FileReader);

    var reader = new window.FileReader();
    /**
     * Instance of native FileReader.
     *
     * @private
     * @member {FileReader} #_reader
     */

    this._reader = reader;
    this._data = undefined;
    /**
     * Number of bytes loaded.
     *
     * @readonly
     * @observable
     * @member {Number} #loaded
     */

    this.set('loaded', 0);

    reader.onprogress = function (evt) {
      _this.loaded = evt.loaded;
    };
  }
  /**
   * Returns error that occurred during file reading.
   *
   * @returns {Error}
   */


  _createClass(FileReader, [{
    key: "error",
    get: function get() {
      return this._reader.error;
    }
    /**
     * Holds the data of an already loaded file. The file must be first loaded
     * by using {@link module:upload/filereader~FileReader#read `read()`}.
     *
     * @type {File|undefined}
     */

  }, {
    key: "data",
    get: function get() {
      return this._data;
    }
    /**
     * Reads the provided file.
     *
     * @param {File} file Native File object.
     * @returns {Promise.<String>} Returns a promise that will be resolved with file's content.
     * The promise will be rejected in case of an error or when the reading process is aborted.
     */

  }, {
    key: "read",
    value: function read(file) {
      var _this2 = this;

      var reader = this._reader;
      this.total = file.size;
      return new Promise(function (resolve, reject) {
        reader.onload = function () {
          var result = reader.result;
          _this2._data = result;
          resolve(result);
        };

        reader.onerror = function () {
          reject('error');
        };

        reader.onabort = function () {
          reject('aborted');
        };

        _this2._reader.readAsDataURL(file);
      });
    }
    /**
     * Aborts file reader.
     */

  }, {
    key: "abort",
    value: function abort() {
      this._reader.abort();
    }
  }]);

  return FileReader;
}();

export { FileReader as default };
mix(FileReader, ObservableMixin);